var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTickFilled = function SvgTickFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "url(#tick-filled_svg__pvpw7l67aa)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.562 31.5c-.402 0-.805-.163-1.113-.494l-5.989-6.41a1.769 1.769 0 010-2.38 1.5 1.5 0 012.223 0l4.88 5.223 9.754-10.447a1.5 1.5 0 012.223 0 1.769 1.769 0 010 2.38L22.672 31.006a1.518 1.518 0 01-1.11.494z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "tick-filled_svg__pvpw7l67aa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(14.00496 31.10581 -32.3534 14.56667 9.996 12.894)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgTickFilled;